import SiteLayout from "@/components/feature/SiteLayout";
import PageHero from "@/components/base/PageHero";
import useDocumentMeta from "@/hooks/useDocumentMeta";
import ContactSection from "@/pages/home/components/ContactSection";

export default function Contact() {
  useDocumentMeta({
    title: "İletişim & Randevu | d.mar Dental Görüntüleme Merkezi",
    description:
      "d.mar Dental Görüntüleme Merkezi iletişim ve randevu: Osmanbey / Şişli, İstanbul. Telefon, WhatsApp, adres, çalışma saatleri ve yol tarifi.",
    path: "/iletisim",
  });

  return (
    <SiteLayout>
      <PageHero
        crumb="İletişim"
        eyebrow="İletişim & randevu"
        title="Randevu, ulaşım ve iletişim"
        description="Osmanbey / Şişli'deki merkezimize kolayca ulaşın. Randevu ve sorularınız için en hızlı kanal WhatsApp'tır; bize dilediğiniz zaman yazabilir ya da telefonla ulaşabilirsiniz."
      />
      <ContactSection />
    </SiteLayout>
  );
}